module.exports = __webpack_public_path__ + "static/media/report-activated.ae8768e3.svg";